/* Variant ids resolved server-side so nothing depends on a handle fetch.
   Goggles are ONE flat price: $22.95 (was $39.95), whatever the bundle.
   The 3-mask tier was dropped: it only surfaced in the cart drawer, after the
   bundle decision was made, so it gave margin away without moving AOV, and the
   variant swap behind it was a recurring source of cart bugs.
   gogglesBundle points at the same variant so any older swap logic is a no-op. */
window.IF_ADDON_IDS = {
  goggles: 54136121360731,
  gogglesBundle: 54136121360731,
  protect: 54131547373915,
  giftPouch: 54136214847835,
  giftMystery: 54136215437659
};
window.IF_GOGGLE_PRICES = { standard: 22.95, bundle: 22.95, was: '39.95' };
